<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedLocationPreference"
      multi-select
      searchable
      :label="$t('Work location')"
      :list="locationPreferenceOptions"
      :placeholder="$t('On site, remote or hybrid')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { locationPreferenceOptions } from '@/components/Job/constants'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedLocationPreference: ModelRef<string[]> = defineModel({
  default: () => [],
})
</script>
